import React, { useMemo } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Loader } from 'components/loader/loader';
import { Jumbotron } from 'components/jumbotron/jumbotron';
import useFetch from 'utils/use-fetch';
import { parseHtml } from 'utils/parse-html';

import { Text } from 'types';
import { TextLocation } from '../../enums';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      padding: '100px 0',
      '& ol, ul, li': {
        paddingLeft: '1.5em',
      },
    },
    anchor: {
      textDecoration: 'underline',
      color: theme.palette.primary.main,
      '&:hover': {
        textDecoration: 'none',
      },
    },
  })
);

export function Homepage() {
  const classes = useStyles();

  const { data, loading } = useFetch<Text>(
    `/api/paragraph?location=${TextLocation.HOMEPAGE}`
  );

  const htmlString = data?.text ?? '';

  const content = useMemo(() => parseHtml(htmlString, () => {}, classes), [
    htmlString,
    classes,
  ]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Jumbotron title="Vítejte v Badatelně Archivu Univerzity Karlovy" />
        <Grid container className={classes.content}>
          <Grid item xs={1} md={3} />
          <Grid item xs={10} md={6}>
            {loading ? (
              <Loader />
            ) : (
              <Typography variant="body1" align="justify">
                {content}
              </Typography>
            )}
            <Grid item xs={1} md={3} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
